import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/** The QR on a stage sheet, on screen and on paper: a link that opens this job at this stage — scanned by a
 * phone, the in-app Scan button or a handheld scanner. The server draws it; it holds only the link, so what a
 * scan shows is always current and behind login. */
export default function StageQr({ jobId, stage, size = 22 }) {
  const [svg, setSvg] = useState("");
  useEffect(() => {
    if (!jobId) return undefined;
    let off = false;
    api.get(`/jobs/${jobId}/qr`, { params: { stage, v: 2 }, responseType: "text", transformResponse: (r) => r })
      .then(({ data }) => !off && setSvg(data))
      .catch(() => {});
    return () => { off = true; };
  }, [jobId, stage]);
  if (!svg) return null;
  return (
    <div className="shrink-0 [&>svg]:w-full [&>svg]:h-full" style={{ width: `${size}mm`, height: `${size}mm` }} data-testid="stage-qr"
      title="Scan to open this job at this stage" dangerouslySetInnerHTML={{ __html: svg }} />
  );
}
